import { render } from "./JobInfo.vue?vue&type=template&id=5aeca957&scoped=true"
import script from "./JobInfo.vue?vue&type=script&lang=js"
export * from "./JobInfo.vue?vue&type=script&lang=js"

import "./JobInfo.vue?vue&type=style&index=0&id=5aeca957&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aeca957"]])

export default __exports__